export const COMMON_ERROR_MESSAGE = "Oops! something went wrong, please contact system administrator.";
export const COMMON_SAVE_ERROR_MESSAGE = "Oops! something went wrong";

export const COMMON_SUCCESSFULL_MESSAGE = "Successfully saved";
export const COMMON_SUCCESSFULL_SENT = "Successfully sent"
export const COMMON_SUCCESSFULL_DELETE_MESSAGE = "Successfully deleted"
export const EVENT_CONFIRMED_MESSAGE = "Event confirmed successful"
export const EVENT_DECLINED_MESSAGE = "Successfully declined sessions"
export const ACCEPT_SUCCESSFULL_MESSAGE = "Successfully Accepted"
export const DECLINE_SUCCESSFULL_MESSAGE = "Successfully declined"